export default {
    loading: false,   // 全局加载状态
    admin  : null,    // 管理员信息
}